import { useState } from 'react';
import { Collapse, List, ListItemButton, ListItemText, } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { MenuItem } from './MenuItem';

type Props = {
    parentLabel: string;
    childMenus: { label: string, path: string }[];
}

export const NestedMenuItem = ({ parentLabel, childMenus }: Props) => {
    const [open, setOpen] = useState(true);

    const handleClick = () => {
        setOpen(!open);
    };

    return (
        <>
            <ListItemButton onClick={handleClick}>
                <ListItemText primary={parentLabel} />
                {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </ListItemButton>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    {childMenus.map((menu, index) => (
                        <MenuItem key={index} label={menu.label} path={menu.path} pl={4} />
                    ))}
                </List>
            </Collapse>
        </>
    )
}
